export default "__VITE_ASSET__DhjQwgys__"